var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoAgregarProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 91,
    viewBox: "0 0 87 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31028 2.4232L8.90028 2.65142C0.800969 7.11213 -2.26394 16.4204 1.76936 24.2189C2.59439 25.8165 3.45085 27.3662 4.30732 28.7698C8.74307 36.0251 38.8916 107.031 53.0768 87.6662C67.2619 68.3011 89.4356 33.6048 86.782 28.7629C84.1283 23.9211 77.0276 15.0453 69.049 15.0453C65.9174 15.0453 61.2842 16.0392 56.8095 17.2477C48.6863 19.441 39.9669 16.2914 35.6695 9.64431L34.7954 8.29206C29.5711 0.223082 18.1139 -2.41637 9.31028 2.4232Z",
    fill: "#F0F0EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 46C63.5 47.6875 62.0938 49.0938 60.5 49.0938H47V62.5938C47 64.1875 45.5938 65.5 44 65.5C42.3125 65.5 41 64.1875 41 62.5938V49.0938H27.5C25.8125 49.0938 24.5 47.6875 24.5 46C24.5 44.4062 25.8125 43.0938 27.5 43.0938H41V29.5938C41 27.9062 42.3125 26.5 44 26.5C45.5938 26.5 47 27.9062 47 29.5938V43.0938H60.5C62.0938 43 63.5 44.4062 63.5 46Z",
    fill: "#164453"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAgregarProyecto);
export default __webpack_public_path__ + "static/media/icono_agregarProyecto.705c3e97382129e75a4a39d56367c953.svg";
export { ForwardRef as ReactComponent };